import { Component, inject, OnInit } from '@angular/core';
import { ASSETS } from '@core/constants/assets.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
//import { UserService } from '@core/services/user.service';
import { UserProfile } from '@core/models/user.model';
import { AuthService } from '@core/auth/services/auth.service';

@Component({
  selector: 'app-auth-header',
  imports: [CommonModule, RouterLink],
  templateUrl: './auth-header.html',
  styleUrl: './auth-header.scss',
})
export class AuthHeader implements OnInit {
  ASSETS = ASSETS;
  APP_ROUTES = APP_ROUTES;
  constructor(private router: Router) {}

  ngOnInit() {
  }

  navigateToHelpCenter() {
    this.router.navigate([APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.HELP_CENTER]);
  }
}
